<template>
    <div>
        <div class="list-item">
            <div class="item-left">
                <div class="item-logo">
                    <router-link :to="'/strategysquare/' + strategyId" :key="strategyId">
                        <img :src="'/svg/' + strategyId + '.svg'">
                    </router-link>
                </div>
            </div>
            <div class="item-right">
                <div class="item-right-t">
                    <div class="item-details">
                        <router-link :to="'/strategysquare/' + strategyId" :key="strategyId">
                            <h3 @click="buriedPoints">{{strategyName}}</h3>
                        </router-link>
                        <div class="item-label">
                            <span v-for="(item, index) in strategyTags" :key="index" v-if="item">{{item}}</span>
                        </div>
                        <p><b>投资逻辑：</b>{{strategyLogic}}</p>
                    </div>
                    <div class="item-annual-income">
                        <p :class="strategyAnnualYield | riseAndFallClass">{{strategyAnnualYield | safePercentFixedTwo}}</p>
                        <span>年化收益</span>
                    </div>
                    <div class="item-success-rate">
                        <p :class="strategyWinRate | riseAndFallClass">{{strategyWinRate | safePercentFixedTwo}}</p>
                        <span>成功率</span>
                    </div>
                    <div class="item-user">
                        <div class="item-user-img right">
                            <img :src="strategyAvatar">
                        </div>
                        <p class="right">{{strategyUser}}</p>
                    </div>
                </div>
                <div class="item-right-b">
                    <div class="item-comment">
                        <span>评论({{strategyCommentNum}})</span>
                    </div>

                    <div
                        style="cursor: pointer"
                        class="item-collect"
                        :class="isCollected ? 'active' : ''"
                        @click="isCollected ? removeCollection(strategyId) : addCollection(strategyId)">
                        <div class="item-collect">
                            <span>{{ isCollected ? '已收藏' : '收藏(' + strategyCollectNum + ')' }}</span>
                        </div>
                    </div>

                    <div
                        v-if="isshowitemstock"
                        style="cursor: pointer"
                        class="item-stock"
                        :class="isshoworder ? 'active': ''"
                        @click="isshoworder ? closeTodayStock(strategyId) : showTodayStock(strategyId)">
                        <span>今日选股</span>
                    </div>

                    <div class="item-set-date">
                        <span>创建时间：{{strategyCtime}}</span>
                    </div>
                </div>
                <pickstock
                    v-show="isshoworder"
                    :transactiontype="'' + strategyType"
                    :select-data="pickData"
                    :classname="'item-stock-list'"
                    :buy-position="buyPosition">
                </pickstock>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios'
    import pickstock from '../strategybacktest/strategy-select'
    export default {
        name: 'itemrow',
        components: {
            pickstock: pickstock
        },
        data () {
            return {
                myBarOption: {
                    barWidth: 9, // 滚动条宽度
                    barMarginRight: 3, // 垂直滚动条距离整个容器右侧距离单位
                    horizrailenabled: false // 是否显示水平滚动条
                },
                isCollected: false,
                showOrder: '',
                isshowitemstock: false,
                isshoworder: false,
                strategyTime: '',
                stocksList: [],
                pickData: null
            }
        },
        computed: {
            buriedPoint () {
                return this.$buriedPoint.strategySquare
            }
        },
        filters: {
            positionControl (num) {
                switch (num) {
                case 1:
                    return '满仓'
                case 0:
                    return '空仓'
                default:
                    return Number(num * 100) + '%'
                }
            },
            closePrices (num) {
                return !num ? '--' : Number(num)
            }
        },
        methods: {
            buriedPoints () {
                window.TA.log({id: this.buriedPoint.inStrategyDetails + '.' + ((this.page - 1) * 10 + this.indexSerial), targid: this.strategyId})
            },
            addCollection (id) {
                window.TA.log(this.buriedPoint.collect)
                var self = this
                axios.post('/strategysquare/collect', {
                    strategyId: id
                }).then((res) => {
                    if (res) {
                        if (res.data.errorcode === 0) {
                            self.$tip({
                                message: '策略收藏成功',
                                duration: 2000,
                                type: 'success'
                            })
                            self.isCollected = true
                            self.$store.dispatch('myStrategy/requestCollectBacktest')
                        } else {
                            self.$tip({
                                message: (res.data.errormsg ? res.data.errormsg : '策略收藏失败'),
                                duration: 2000,
                                type: 'error'
                            })
                        }
                    }
                }).catch((error) => {
                    self.$tip({
                        message: (error ? error.message : '策略收藏失败'),
                        duration: 2000,
                        type: 'error'
                    })
                })
            },
            removeCollection (id) {
                window.TA.log(this.buriedPoint.collectCancel)
                var self = this
                axios.post('/strategysquare/uncollect', {
                    strategyId: id
                }).then((res) => {
                    if (res) {
                        if (res.data.errorcode === 0) {
                            self.$tip({
                                message: '策略取消收藏成功',
                                duration: 2000,
                                type: 'success'
                            })
                            self.isCollected = false
                            self.$store.dispatch('myStrategy/requestCollectBacktest')
                        }
                    }
                }).catch((error) => {
                    self.$tip({
                        message: (error ? error.message : '策略取消收藏失败'),
                        duration: 2000,
                        type: 'error'
                    })
                })
            },
            closeTodayStock () {
                window.TA.log(this.buriedPoint.todayStockClose)
                this.isshoworder = false
            },
            showTodayStock (id) {
                window.TA.log(this.buriedPoint.todayStockOpen)
                this.isshoworder = true
                this.showTodayStockData(id)
            },
            showTodayStockData (id) {
                var self = this
                if (this.isshoworder) {
                    axios.get('/strategysquare/pickstock', {params: {
                        strategyId: id
                    }
                    }).then((res) => {
                        if (res.data.errorcode !== 0) {
                            self.$tip({
                                message: '获取选股数据有误',
                                duration: 2000,
                                type: 'error'
                            })
                            return
                        }

                        let data = res.data.result
                        self.pickData = data
                        self.strategyTime = data.date
                        if (data.stocks.length === 0) {
                            self.stocksList = []
                        } else {
                            self.stocksList = data.stocks
                        }
                    }).catch(function (error) {
                        self.$tip({
                            message: error ? error.message : '网络异常',
                            duration: 2000,
                            type: 'error'
                        })
                    })
                }
            }
        },
        mounted () {
            this.isCollected = this.strategyIsCollected
            if (this.indexSerial < 3 && this.indexSerial >= 0 && this.page === 1) {
                this.isshowitemstock = true
            }
        },
        props: {
            buyPosition: Number,
            indexSerial: {
                type: Number,
                default: null
            },
            page: {
                type: Number,
                default: null
            },
            strategyId: {
                type: Number,
                default: ''
            },
            strategyName: {
                type: String,
                default: ''
            },
            strategyLogic: {
                type: String,
                default: ''
            },
            strategyCtime: {
                type: String,
                default: ''
            },
            strategyAnnualYield: {
                type: String,
                default: '0.00%'
            },
            strategyWinRate: {
                type: String,
                default: '0.00%'
            },
            strategyTags: {
                type: Array,
                default: []
            },
            strategyUser: {
                type: String,
                default: ''
            },
            strategyAvatar: {
                type: String,
                default: ''
            },
            strategyUserId: {
                type: Number,
                default: ''
            },
            strategyCollectNum: {
                type: Number,
                default: 0
            },
            strategyCommentNum: {
                type: Number,
                default: 0
            },
            strategyIsCollected: {
                type: Boolean,
                default: false
            },
            strategyType: {
                type: Number,
                default: 1
            },
            resetStock: {
                type: Boolean,
                default: false
            }
        },
        watch: {
            resetStock () {
                this.isshoworder = false
                this.pickData = null
            },
            page (val) {
                if (this.indexSerial < 3 && this.indexSerial >= 0 && val === 1) {
                    this.isshowitemstock = true
                } else {
                    this.isshowitemstock = false
                    this.isshoworder = false
                }
            },
            strategyIsCollected (val) {
                this.isCollected = val
            },
            strategyId (val) {
                this.showTodayStockData(val)
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import '../../scss/strategysquare/item-row.scss';
</style>



// WEBPACK FOOTER //
// src/components/strategysquare/item-row.vue